<template>
    <div class="home">
        <Cheader></Cheader>
        <div class="formBox">
            <div class="bg">
                <div class="title">
                    <div>江西省2025年高等职业教育单独招生</div>
                    <div class="font">模拟练习平台</div>
                    <!-- <img src="@/assets/sub_title.png" alt=""> -->
                </div>
                <div class="form-login">
                    <Login></Login>
                </div>
            </div>
        </div>
        <Contents></Contents>
    </div>
</template>
<script>
import Contents from './content.vue'
import Login from '../../components/login.vue'
import Cheader from '../../components/header.vue'
export default {
    name: 'homePage',
    data() {
        return {
        }
    },
    components: {
        Contents,
        Login,
        Cheader
    },
}
</script>
<style scoped lang="scss">
.home{
    width: 100%;
    height: 100%;
    position: relative;
    overflow-y: auto;
    *{
        box-sizing: border-box;
    }
    .formBox{
        height: 629px;
        width: 100%;
        background-image: url('https://img.js.design/assets/img/6343ec75025a07c7c97ea2a6.png#76d4c986e2b3a6a8b9e1ec86bdd3c7bb');
        background-size: cover;
        .bg{
            width: 100%;
            height: 100%;
            background: linear-gradient(270deg, rgba(0, 0, 0, 0.65) 0%, rgba(0, 0, 0, 0.3) 51.1%, rgba(0, 0, 0, 0.45) 100%);
            display: flex;
            justify-content: center;
            align-items: center;
            .title{
                width: 727px;
                font-size: 41px;
                font-weight: 600;
                color: #fff;
                margin-right: 127px;
                padding-bottom: 134px;
                &>div{
                    min-height: 102px;
                    display: flex;
                    align-items: center;
                }
                .font{
                    color: #73c4f0;
                    font-size: 47px;
                    letter-spacing: 3px;
                }
                img{
                    width: 769px;
                    display: inline-block;
                    user-select: none;
                    -webkit-user-drag: none;
                }
            }
            .form-login{
                height: 100%;
                padding-top: 32px;
            }
        }
    }
}
</style>